import { useCallback, useState } from "react";
import { slugValidationError } from "../../shared/slug";

export function useSlugField({
  currentSlug,
  allItems,
  currentId,
  onCommit,
}: {
  currentSlug: string | undefined;
  allItems: readonly { id: string; slug: string }[];
  currentId: string;
  onCommit: (slug: string) => void;
}) {
  const [editValue, setEditValue] = useState<string | null>(null);
  const value = editValue ?? currentSlug ?? "";

  const error =
    editValue !== null && editValue !== ""
      ? slugValidationError(editValue)
      : null;
  const slugTaken =
    editValue !== null &&
    editValue !== currentSlug &&
    allItems.some((item) => item.id !== currentId && item.slug === editValue);

  const commit = useCallback(() => {
    if (editValue === null) return;
    if (
      editValue === "" ||
      editValue === currentSlug ||
      error !== null ||
      slugTaken
    ) {
      setEditValue(null);
      return;
    }
    onCommit(editValue);
    setEditValue(null);
  }, [editValue, currentSlug, error, slugTaken, onCommit]);

  return { value, setValue: setEditValue, error, slugTaken, commit };
}
